import { render, staticRenderFns } from "./VoucherContent.vue?vue&type=template&id=bb043458&scoped=true&"
import script from "./VoucherContent.vue?vue&type=script&lang=js&"
export * from "./VoucherContent.vue?vue&type=script&lang=js&"
import style0 from "./VoucherContent.vue?vue&type=style&index=0&id=bb043458&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb043458",
  null
  
)

export default component.exports